
export enum CategoryOptionType {
    ModuleConfig = 'Module Config',
    TenantConfig = 'EHS Tenant Config',
    MandatoryCopyProcesses = 'Mandatory Copy Processes'
}
